import type React from "react";
import { ShieldX, RefreshCw } from "lucide-react";
import { i18n } from "@frontend/i18n";
import { Button } from "@planta-v2/pds-ui/button";
import { cn } from "@planta-v2/pds-ui/lib/utils";

export interface UnauthorizedStateProps {
  readonly message?: string | undefined;

  readonly onRetry?: (() => void) | undefined;

  readonly retryLabel?: string | undefined;

  readonly testId?: string | undefined;

  readonly className?: string | undefined;
}

export function UnauthorizedState({
  message,
  onRetry,
  retryLabel,
  testId = "unauthorized-state",
  className,
}: UnauthorizedStateProps): React.JSX.Element {
  const displayMessage = message ?? i18n.t("common.unauthorized.message");
  const buttonLabel = retryLabel ?? i18n.t("common.retry");

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center py-12 px-4",
        className,
      )}
      data-testid={testId}
    >
      <ShieldX className="h-12 w-12 text-destructive mb-4" />
      <h3 className="text-sm font-medium text-foreground mb-1">
        {i18n.t("common.unauthorized.title")}
      </h3>
      <p className="text-xs text-muted-foreground text-center mb-4">
        {displayMessage}
      </p>
      {onRetry !== undefined && (
        <Button
          variant="secondary"
          onClick={onRetry}
          className="gap-2"
          data-testid={`${testId}-retry-button`}
        >
          <RefreshCw className="h-4 w-4" />
          {buttonLabel}
        </Button>
      )}
    </div>
  );
}
